package com.example.mystybag.login.views

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import com.example.mystybag.login.views.components.WebInlineLanguageSwitcher
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.example.mystybag.common.extensions.AsyncImage
import com.example.mystybag.core.ui.theme.LocalTheme
import com.example.mystybag.core.views.AppTheme

/**
 * JS actual: Compose-rendered desktop header (brand mark + text on the left,
 * Help / language selector on the right). The previous version was injected
 * as a separate DOM overlay above the image overlay because the photo lived
 * on its own DOM layer; with the image now painted directly on the Skiko
 * canvas, the header is just a regular Compose Row sitting in the natural
 * z-order.
 */
@Composable
actual fun WelcomeDesktopHeaderActions(
    brandIconUrl: String,
    brandText: String,
    onHelpClick: () -> Unit,
) {
    val colors = AppTheme.current.colors

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 40.dp, vertical = 32.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            AsyncImage(
                link = brandIconUrl,
                placeholder = null,
                modifier = Modifier
                    .width(40.dp)
                    .height(40.dp)
                    .clip(RoundedCornerShape(10.dp)),
                contentScale = ContentScale.Fit
            )
            Text(
                text = brandText,
                color = colors.onSurface,
                fontFamily = LocalTheme.googleSans,
                fontSize = 24.sp,
                lineHeight = 40.sp,
                fontWeight = FontWeight.Bold
            )
        }

        Row(
            horizontalArrangement = Arrangement.spacedBy(24.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(modifier = Modifier.clickable { onHelpClick() }) {
                HeaderActionText(text = "Help")
            }
            WebInlineLanguageSwitcher(
                triggerTextColor = Color.White,
                chevronTint = Color.White
            )
        }
    }
}

@Composable
private fun HeaderActionText(text: String) {
    Text(
        text = text,
        color = Color.White,
        fontFamily = LocalTheme.googleSans,
        fontSize = 16.sp,
        lineHeight = 24.sp,
        letterSpacing = 0.5.sp,
        fontWeight = FontWeight.Normal,
        textAlign = TextAlign.Center
    )
}
